// Strips a leading US country code, then keeps at most 10 digits.
const toDigits = (value) => {
  let digits = String(value ?? "").replace(/\D/g, "");
  if (digits.length > 10 && digits.startsWith("1")) digits = digits.slice(1);
  return digits.slice(0, 10);
};

// Progressive US mask: (XXX) XXX-XXXX.
export const formatPhoneNumber = (value) => {
  const d = toDigits(value);
  if (d.length === 0) return "";
  if (d.length <= 3) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
};

export const isValidPhoneNumber = (value) =>
  String(value ?? "").replace(/\D/g, "").length === 10;
